import { useState, useEffect } from 'react';
import { readerRequests } from 'services';
import { skeletonFactory, useHandleRequest } from 'shared';

const readerRequestDummy = skeletonFactory.readerRequest();

export function useReaderRequest(id) {
  const [readerRequestData, setReaderRequestData] = useState(id ? readerRequestDummy : {});
  const { request, errorInfo, setErrorInfo } = useHandleRequest();

  useEffect(() => {
    async function getData() {
      await request(async () => {
        const response = await readerRequests.getById(id);
        if (response) {
          setReaderRequestData(response.data || {});
        }
      }, false);
    }
    id && getData();
  }, [request, id]);

  return {
    readerRequest: readerRequestData,
    errorInfo,
    setErrorInfo,
    setReaderRequestData
  };
}
